<td class="col-id text-uppercase"
	[attr.title]="!reportErrorColumn.column ? undefined : (reportErrorColumn.isExtraData ? reportErrorColumn.label : columnName)"
	(click)="$event.stopPropagation()">
	{{ columnMapping(reportErrorColumn.column) }}
</td>

<td class="col-error-msg">
	<span [translate]="errorMessage.key" [translateParams]="errorMessage.params"></span>
</td>

<td class="col-small-amount">{{ reportErrorColumn.errorCount }}</td>

<td class="col-small-status">
	<span [translate]="'Import.Creation.ValidationAndProcessing.ImportInstanceDetailStatus.'+ reportErrorColumn.status"></span>
</td>

<td class="col-error-description">
	@if (reportErrorColumn.firstActionDetail) {
		<span [translate]="'Import.Creation.ValidationAndProcessing.ReportActionDetail.'+ reportErrorColumn.firstActionDetail"></span>
	}
</td>

<td class="col-btn-expand">
	@if (hasErrorReportLine(reportErrorColumn)) {
		<i class="far fa-angle-down"></i>
	}
</td>
